var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-activity_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-activity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.598 14.356l3.057-4.645a.141.141 0 00.009-.142c-.023-.048-.062-.072-.118-.072h-2.235l1.357-5.057a.2.2 0 00-.033-.192.203.203 0 00-.169-.09H7.408a.26.26 0 00-.27.274v6.399a.26.26 0 00.27.274h2.19v3.25zm4.218-4.352l-4.401 6.762a.5.5 0 01-.265.205.597.597 0 01-.317.014.456.456 0 01-.266-.177.546.546 0 01-.108-.342v-4.203H7.41c-.39 0-.721-.14-.996-.42A1.391 1.391 0 016 10.831v-6.4c0-.394.138-.732.413-1.011.275-.28.607-.42.995-.42h3.89c.48 0 .868.19 1.167.568.299.378.385.807.26 1.287l-.937 3.484h1.152c.416 0 .723.187.922.562.198.374.183.742-.046 1.103z",
    fill: "#50545E"
  }))));
}
export default SvgIcnActivity;